// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1yBrJ","location":"Header_location__1BIP1"};